import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-si-glyph-upstair",
  "use": "icon-si-glyph-upstair-usage",
  "viewBox": "0 0 17 16",
  "content": "<symbol viewBox=\"0 0 17 16\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" class=\"si-glyph si-glyph-upstair\" id=\"icon-si-glyph-upstair\">\n    <!-- Generator: Sketch 3.0.3 (7891) - http://www.bohemiancoding.com/sketch -->\n    <title>1050</title>\n    \n    <defs></defs>\n    <g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <g transform=\"translate(1.000000, 1.000000)\" fill=\"#434343\">\n            <path d=\"M15.969,0.047 L13.073,0.047 L13.073,2.047 L11.062,2.047 L11.062,4.047 L9.052,4.047 L9.052,6.047 L7.043,6.047 L7.043,8.047 L5.031,8.047 L5.031,10.047 L3.021,10.047 L3.021,12.047 L0,12.047 L0,14.965 L2.896,14.965 L16,2.965 L15.969,0.047 Z\" class=\"si-glyph-fill\" />\n            <path d=\"M6.873,0.104 L1.949,0.104 L4.104,1.518 L0.922,4.698 L2.248,6.024 L5.429,2.843 L6.877,5.048 L6.873,0.104 Z\" class=\"si-glyph-fill\" />\n        </g>\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/glyph/si-glyph-upstair.svg
// module id = rgmi
// module chunks = 62